/**
 * Google Analytics 服务
 * 用于跟踪用户行为和网站性能
 */

class AnalyticsService {
  constructor() {
    this.isInitialized = false
    this.init()
  }

  // 初始化Google Analytics
  init() {
    if (typeof window !== 'undefined' && window.gtag) {
      this.isInitialized = true
      console.log('Google Analytics initialized')
    } else {
      // 如果gtag未加载，延迟重试
      setTimeout(() => this.init(), 1000)
    }
  }

  // 页面浏览跟踪
  trackPageView(pageTitle, pagePath) {
    if (!this.isInitialized) return

    try {
      window.gtag('config', 'G-45VN2LK7EM', {
        page_title: pageTitle,
        page_location: window.location.href,
        page_path: pagePath
      })
      console.log('Page view tracked:', pageTitle)
    } catch (error) {
      console.error('Error tracking page view:', error)
    }
  }

  // 游戏开始事件
  trackGameStart(gameName, gameCategory) {
    if (!this.isInitialized) return

    try {
      window.gtag('event', 'game_start', {
        event_category: 'Games',
        event_label: gameName,
        game_name: gameName,
        game_category: gameCategory
      })
      console.log('Game start tracked:', gameName)
    } catch (error) {
      console.error('Error tracking game start:', error)
    }
  }

  // 游戏完成事件
  trackGameComplete(gameName, gameCategory, playTime) {
    if (!this.isInitialized) return

    try {
      window.gtag('event', 'game_complete', {
        event_category: 'Games',
        event_label: gameName,
        game_name: gameName,
        game_category: gameCategory,
        play_time: playTime
      })
      console.log('Game complete tracked:', gameName)
    } catch (error) {
      console.error('Error tracking game complete:', error)
    }
  }

  // 搜索事件
  trackSearch(searchTerm, resultsCount) {
    if (!this.isInitialized) return

    try {
      window.gtag('event', 'search', {
        search_term: searchTerm,
        results_count: resultsCount
      })
      console.log('Search tracked:', searchTerm)
    } catch (error) {
      console.error('Error tracking search:', error)
    }
  }

  // 分类筛选事件
  trackCategoryFilter(category) {
    if (!this.isInitialized) return

    try {
      window.gtag('event', 'category_filter', {
        event_category: 'Navigation',
        event_label: category,
        category: category
      })
      console.log('Category filter tracked:', category)
    } catch (error) {
      console.error('Error tracking category filter:', error)
    }
  }

  // 用户注册事件
  trackUserRegistration(method) {
    if (!this.isInitialized) return

    try {
      window.gtag('event', 'sign_up', {
        method: method
      })
      console.log('User registration tracked:', method)
    } catch (error) {
      console.error('Error tracking user registration:', error)
    }
  }

  // 用户登录事件
  trackUserLogin(method) {
    if (!this.isInitialized) return

    try {
      window.gtag('event', 'login', {
        method: method
      })
      console.log('User login tracked:', method)
    } catch (error) {
      console.error('Error tracking user login:', error)
    }
  }

  // 错误事件
  trackError(errorMessage, errorCode) {
    if (!this.isInitialized) return

    try {
      window.gtag('event', 'exception', {
        description: errorMessage,
        fatal: false,
        error_code: errorCode
      })
      console.log('Error tracked:', errorMessage)
    } catch (error) {
      console.error('Error tracking error event:', error)
    }
  }

  // 自定义事件
  trackCustomEvent(eventName, parameters = {}) {
    if (!this.isInitialized) return

    try {
      window.gtag('event', eventName, parameters)
      console.log('Custom event tracked:', eventName, parameters)
    } catch (error) {
      console.error('Error tracking custom event:', error)
    }
  }

  // 设置用户属性
  setUserProperty(propertyName, propertyValue) {
    if (!this.isInitialized) return

    try {
      window.gtag('config', 'G-45VN2LK7EM', {
        custom_map: {
          [propertyName]: propertyValue
        }
      })
      console.log('User property set:', propertyName, propertyValue)
    } catch (error) {
      console.error('Error setting user property:', error)
    }
  }

  // 设置用户ID
  setUserId(userId) {
    if (!this.isInitialized) return

    try {
      window.gtag('config', 'G-45VN2LK7EM', {
        user_id: userId
      })
      console.log('User ID set:', userId)
    } catch (error) {
      console.error('Error setting user ID:', error)
    }
  }
}

// 创建单例实例
const analyticsService = new AnalyticsService()

export default analyticsService 